"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayout = exports.AppLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var react_helmet_1 = require("react-helmet");
var theme_2 = require("@shapeable/theme");
var sidebar_1 = require("./sidebar");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_app_options_1 = require("../../hooks/use-app-options");
var use_app_sections_1 = require("../../hooks/use-app-sections");
var use_entities_1 = require("../../hooks/use-entities");
var use_entity_definition_for_plural_slug_1 = require("../../hooks/use-entity-definition-for-plural-slug");
var use_lang_1 = require("../../hooks/use-lang");
var use_modal_1 = require("../../hooks/use-modal");
var use_sidebar_1 = require("../../hooks/use-sidebar");
var global_style_1 = require("../elements/global-style");
var app_screen_context_1 = require("../context/app-screen-context");
var sidebar_layout_info_context_1 = require("../context/sidebar-layout-info-context");
var modal_1 = require("../elements/modal");
var modal_loader_1 = require("../elements/modal-loader");
var use_app_state_1 = require("../../hooks/use-app-state");
var lodash_1 = require("lodash");
var loading_layout_1 = require("../elements/loading-layout");
var use_icons_1 = require("../../hooks/use-icons");
var use_app_metadata_1 = require("../../hooks/use-app-metadata");
var form_state_context_v2_1 = require("../../v2/context/form-state-context-v2");
var form_field_components_context_1 = require("../../v2/context/form-field-components-context");
exports.AppLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    // align-items: stretch;\n    width: 100vw;\n    min-width: 320px;\n    background: #F5F5F5;\n    font-family: ", "; \n    overflow: hidden;\n\n    > div {\n      /* Router component injects a div here */\n      // flex-grow: 1;\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    // align-items: stretch;\n    width: 100vw;\n    min-width: 320px;\n    background: #F5F5F5;\n    font-family: ", "; \n    overflow: hidden;\n\n    > div {\n      /* Router component injects a div here */\n      // flex-grow: 1;\n    }\n  "])), theme_2.theme.FONT('sans'))
});
var SidebarContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    height: 100vh;\n    position: fixed;\n    left: 0;\n    z-index: 100;\n    transition: left 0.3s;\n    ", "\n  "], ["\n    display: flex;\n    height: 100vh;\n    position: fixed;\n    left: 0;\n    z-index: 100;\n    transition: left 0.3s;\n    ", "\n  "])), function (props) {
    return !props.isShown && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      left: -320px;\n    "], ["\n      left: -320px;\n    "])));
  })
});
var SidebarUnderlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100vh;\n    width: 100vw;\n    z-index: 99;\n    background-color: ", "99;\n    position: fixed;\n    top: 0;\n    left: 0;\n  "], ["\n    height: 100vh;\n    width: 100vw;\n    z-index: 99;\n    background-color: ", "99;\n    position: fixed;\n    top: 0;\n    left: 0;\n  "])), theme_2.theme.COLOR('app-chrome')),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 100vh;\n    width: 320px;\n    box-shadow: 0 2px 7px -5px rgba(0,0,0,0.7);\n    flex-shrink: 0;\n    z-index: 101;\n  "], ["\n    height: 100vh;\n    width: 320px;\n    box-shadow: 0 2px 7px -5px rgba(0,0,0,0.7);\n    flex-shrink: 0;\n    z-index: 101;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-shadow: none;\n    width: 280px;\n  "], ["\n    box-shadow: none;\n    width: 280px;\n  "]))),
  desktopLarge: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 320px;\n  "], ["\n    width: 320px;\n  "])))
});
var ModalStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    z-index: 500;\n  "], ["\n    z-index: 500;\n  "])))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    min-height: 100vh;\n  "], ["\n    min-height: 100vh;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SidebarContainer: styled_components_1.default.aside(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SidebarContainerStyles),
  SidebarUnderlay: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SidebarUnderlayStyles),
  Sidebar: (0, styled_components_1.default)(sidebar_1.Sidebar)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Modal: (0, styled_components_1.default)(modal_1.Modal)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles),
  ModalLoader: (0, styled_components_1.default)(modal_loader_1.ModalLoader)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles)
};
var AppLayout = function (props) {
  var className = props.className,
    children = props.children;
  var sidebar = (0, use_sidebar_1.useSidebar)();
  var sidebarState = (sidebar === null || sidebar === void 0 ? void 0 : sidebar.state) || {
    isShown: true
  };
  var person = (0, use_active_person_1.useActivePerson)().person;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var applicationOptions = (0, use_app_options_1.useAppOptions)();
  var appSections = (0, use_app_sections_1.useAppSections)();
  var _a = __read((0, use_app_state_1.useAppState)(), 1),
    appState = _a[0];
  var metadata = (0, use_app_metadata_1.useAppMetadata)();
  var modal = (0, use_modal_1.useModal)();
  var _b = __read((0, use_dimensions_1.useDimensions)(), 2),
    sidebarRef = _b[0],
    sidebarInfo = _b[1];
  var sidebarWidth = sidebarInfo.width || 0;
  var pathInfo = props['*'];
  var parts = pathInfo.split('/');
  // try to find an entity definition
  var entityDefinition = !!parts.length && (0, use_entity_definition_for_plural_slug_1.useEntityDefinitionForPluralSlug)(parts[0]);
  var isHome = (0, lodash_1.includes)(['following', 'profile', 'connections', 'conversations', 'network', ''], pathInfo);
  var isList = entityDefinition && parts.length > 1 && parts[1] === 'list';
  var isDetails = entityDefinition && !isList;
  var isManage = parts.length > 0 && parts[0] === 'manage';
  var slug = isDetails && parts.length > 1 && parts[1];
  var child = isDetails && parts.length > 2 && parts[2];
  var icons = (0, use_icons_1.useIcons)();
  var screenType = 'other';
  var homeSection = appSections.find(function (appSection) {
    return appSection.id === 'home';
  });
  if (isList) {
    screenType = 'list';
  } else if (isDetails) {
    screenType = 'details';
  } else if (isManage) {
    screenType = 'manage';
  } else if (isHome) {
    screenType = 'home';
  }
  var appSection = isHome ? homeSection : appSections.find(function (appSection) {
    return (appSection.children || []).find(function (child) {
      return child.entityTypeName === (entityDefinition === null || entityDefinition === void 0 ? void 0 : entityDefinition.name);
    });
  });
  var detailsChildren = entityDefinition && entityDefinition.details.children({
    t: t,
    icons: icons,
    entities: entities,
    applicationOptions: applicationOptions,
    definition: entityDefinition
  }) || [];
  var detailsChild = detailsChildren && detailsChildren.find(function (dc) {
    return dc.path === child;
  });
  var appScreenInfo = {
    type: screenType,
    appSection: appSection,
    slug: slug,
    child: child,
    detailsChild: detailsChild,
    detailsChildren: detailsChildren,
    entityTypeName: entityDefinition === null || entityDefinition === void 0 ? void 0 : entityDefinition.name
  };
  if (!person) {
    return react_1.default.createElement(My.LoadingLayout, null);
  }
  var showCloseButton = modal.options.showCloseButton !== false;
  return react_1.default.createElement(app_screen_context_1.AppScreenProvider, {
    value: appScreenInfo
  }, react_1.default.createElement(form_field_components_context_1.FormFieldComponentsProvider, null, react_1.default.createElement(form_state_context_v2_1.FormStateProviderV2, null, react_1.default.createElement(My.Container, {
    className: className
  }, appState.isRefreshing && react_1.default.createElement(My.ModalLoader, {
    message: "Refreshing Cached Data. Please wait..."
  }), modal.component && react_1.default.createElement(My.Modal, {
    showCloseButton: showCloseButton
  }, modal.component), react_1.default.createElement(global_style_1.GlobalStyle, null), react_1.default.createElement(react_helmet_1.Helmet, {
    title: metadata.name,
    meta: [{
      name: 'description',
      content: metadata.description
    }]
  }, react_1.default.createElement("html", {
    lang: "en"
  }), metadata.image && react_1.default.createElement("meta", {
    property: 'og:image',
    content: metadata.image
  }), react_1.default.createElement("meta", {
    property: 'og:locale',
    content: 'en_US'
  }), react_1.default.createElement("meta", {
    property: 'og:type',
    content: 'website'
  }), react_1.default.createElement("meta", {
    property: 'og:title',
    content: metadata.name
  }), metadata.description && react_1.default.createElement("meta", {
    property: 'og:description',
    content: metadata.description
  }), react_1.default.createElement("meta", {
    property: 'og:url',
    content: metadata.url
  }), react_1.default.createElement("meta", {
    property: 'og:updated_time',
    content: new Date().toISOString()
  })), react_1.default.createElement(My.SidebarContainer, {
    isShown: sidebarState.isShown,
    ref: sidebarRef
  }, react_1.default.createElement(react_1.default.Fragment, null, sidebarState.isShown && react_1.default.createElement(My.Sidebar, {
    isShown: sidebarState.isShown
  }), sidebarState.isShown && react_1.default.createElement(My.SidebarUnderlay, {
    onClick: function () {
      sidebar.hide();
    }
  }))), react_1.default.createElement(sidebar_layout_info_context_1.SidebarLayoutProvider, {
    value: {
      width: sidebarWidth
    }
  }, children)))));
};
exports.AppLayout = AppLayout;
exports.AppLayout.defaultProps = exports.AppLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;